import React, { useState } from 'react';
import '../App.css';
import axios from 'axios';
import {
    SERVER_URI,
} from "../utility/config";

function ContactUpdatedMessage(props) {
    window.setTimeout(function () {
        props.handleClose();
    }, 1700);
    return (
        <div >
            <h2 className="message_title">Kontakti päivitetty</h2>
        </div>
    );
}

function UpdateContact(props) {
    const [show, setShow] = useState(false);
    const [userData, setUserData] = useState({
        name: props.data.contactData.name,
        phoneNumber: props.data.contactData.phoneNumber,
        email: props.data.contactData.email,
    })
    let storage = window.localStorage;
    let userToken = storage.getItem("admin_token")

    const onChange = (e) => {
        setUserData({ ...userData, [e.target.name]: e.target.value })
    }

    //Submit
    const doSubmit = async (e) => {
        e.preventDefault()
        const dataToServer = {
            ...userData,
            name: String(userData.name),
            phoneNumber: String(userData.phoneNumber),
            email: String(userData.email),
            id: props.data.contactData.id
        }
        const dataToReducer = {
            ...userData,
            name: String(userData.name),
            phoneNumber: String(userData.phoneNumber),
            email: String(userData.email),
            index: props.data.index
        }
            try {
                await axios.put(`${SERVER_URI}/update_contact/${props.data.contactData.id}`, dataToServer, { headers: { "Authorization": `Token ${userToken}` } })
                props.dispatch({ type: "UPDATE_CONTACT", data: { newContact: dataToReducer } })
                setShow(!show);
            } catch (e) {
                console.log("Error updating contact", e)
            }
    }
    return (
        <div className="popUp_card">
            <div className="popup-box">
                <div className="box">
                    <span className="close-icon" onClick={props.handleClose}>x</span>
                    {!show && (
                        <div>
                            <h2 className="popUp_title">Muokkaa kontaktia</h2>
                            <form className="add_driver_form" onSubmit={e => doSubmit(e)}>
                                <label className="label_add" htmlFor="name">Nimi:</label>
                                <input type="text" id="name" name="name" onChange={onChange} defaultValue={props.data.contactData.name} required></input><span className="validity"></span> <br className="desktop-break" />
                                <label className="label_add" htmlFor="email">Sähköposti:</label>
                                <input type="email" id="email" name="email" onChange={onChange} defaultValue={props.data.contactData.email} required></input><span className="validity"></span> <br className="desktop-break" />
                                <label className="label_add" htmlFor="phoneNumber">Puhelinnumero:</label>
                                <input type="tel" id="phoneNumber" name="phoneNumber" defaultValue={props.data.contactData.phoneNumber} onChange={onChange} required></input><span className="validity"></span><br className="desktop-break" />
                                <input type="submit" id="gradient_Button" value="Tallenna muutokset" />
                            </form></div>
                    )}
                    {show && <ContactUpdatedMessage handleClose={props.handleClose} />}
                </div>
            </div>
        </div>

    );
}

export default UpdateContact